import React, { useState } from "react";
import { ColorRing } from "react-loader-spinner";
import DispatchesModal from "./DispatchModal";

const DispatchTable = ({ Dispatches, onEdit, isLoading }) => {

  const [isDispatchModalOpen, setIsDispatchModalOpen] = useState(false);
  const [selectededCallNumber, setSelectedCallNumber] = useState(null);

  const handleModalOpen = (callNumber) => {
    setSelectedCallNumber(callNumber);
    setIsDispatchModalOpen(true);
  };
  const handleModalClose = () => {
    setIsDispatchModalOpen(false);
    setSelectedCallNumber(null);
  }


  if (isLoading) {
    return (
      <div className="flex justify-center items-center">
        <ColorRing
          visible={isLoading}
          height="100"
          width="100"
          ariaLabel="color-ring-loading"
          wrapperStyle={{}}
          wrapperClass="color-ring-wrapper"
          colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
        />
      </div>
    );
  }


  return (<>
    <table className="w-full mt-4 border-collapse border border-gray-300">
      <thead>
        <tr className="bg-gray-300">
          <th className="border p-2">Building</th>
          <th className="border p-2">Mechanic</th>
          <th className="border p-2">Records</th>
        </tr>
      </thead>
      <tbody>
        {Dispatches.map((log) => (
          <tr key={log.callNumber} className={"border-t cursor-pointer"}>

            <td className="border p-2">{log.building?.buildingReference}</td>
            <td className="border p-2">{log.assignedTo?.email}</td>


            <td className="border p-2 flex flex-col justify-center">
              <button className="text-blue-500" onClick={() => onEdit(log)}>Edit</button>
              <button className="text-blue-500" onClick={() => { handleModalOpen(log.callNumber); }}>View</button>
            </td>
          </tr>
        ))}
      </tbody>

    </table>
    <DispatchesModal isOpen={isDispatchModalOpen} onClose={handleModalClose} callNumber={selectededCallNumber} />
  </>

  );
};

export default DispatchTable;